<template>
  <div class="commodity-box-h5">
    <div class="commodity-title-h5">
      <span
        v-if="courseGoods && courseGoods.imgBorder"
        class="commodity-title-h5-text">
        {{courseGoods.blockTitle}}
      </span>
      <div class="commodity-title-h5-more" v-show="courseGoods.showLink" @click="handleGoList">
        <span>{{courseGoods.linkLabel}}</span>
        <span class="el-icon-arrow-right"></span>
      </div>
    </div>
    <div class="commodity-scroll" v-if="goodsList.length">
      <div
        v-for="item in goodsList"
        :key="item.goodsId"
        class="commodity-two-item"
        @click="handleOpenPage(item)"
        :style="commodityTwoStyl">
        <img :src="item.pic" alt="" class="commodity-two-img">
        <div class="commodity-two-item-text">
          <div class="commodity-two-item-title title-ellipsis" >{{item.name}}</div>
          <div class="commodity-tags-placehold">
            <span class="commodity-tags-h5" v-show="courseGoods.showGoodsLabel && item.labelNameList.length" v-if="item.labelNameList !=null">
              {{item.labelNameList[0] | filterStr}}
            </span>
          </div>
          <div class="commodity-price-box-h5" v-if="courseGoods.showGoodsPrice || courseGoods.buyButton">
            <span class="salePrice-h5" v-if="courseGoods.showGoodsPrice">{{item.isFree == 1 ? '免费' : '￥'+ item.price}}</span>
            <span class="apply-btn-h5"
              :style="{'background':courseGoods.buttonColor}"
              v-if="courseGoods.buyButton && courseGoods.buttonLabel">{{courseGoods.buttonLabel}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'commodityTwo',
  props: {
    courseGoods: {
      type: Object,
      default: ()=>{}
    },
    goodsList: {
      type: Array,
      default: ()=>[]
    }
  },
  filters: {
    filterStr(val) {
      let str = '';
      if (val) {
        if (val.length < 10) {
          str = val ? val : ''
        } else {
          str = val.substr(0,10) + '...'
        }
      }
      return str;
    }
  },
  data() {
    return {
    }
  },
  computed: {
    commodityTwoStyl() {
      return {
        boxShadow: '0 2px 8px 0 rgba(0, 0,0, 0.07)'
      }
    }
  },
  mounted() {
    console.log(this.goodsList,'courseGoodsH5-two');
  },
  methods: {
    handleOpenPage(item) {
      this.$emit('detail',item)
    },
    handleGoList() {
      this.$emit('list')
    }
  }
}
</script>
<style lang="less" scoped>
  .commodity-title-h5 {
    border-bottom: 1px solid #F0F0F0;
  }
  .commodity-scroll {
    display: flex;
    padding: 30px 0 30px 30px;
    overflow-x: scroll;
  }
  .commodity-scroll::-webkit-scrollbar {display:none}
  .commodity-two-item {
    width: 300px;
    margin-right: 20px;
    border-radius: 16px;
    height: fit-content;
    box-shadow: 0 2px 8px 0 rgba(0, 0,0, 0.07);
    .commodity-two-img {
      width: 300px;
      border-radius: 16px 16px 0 0;
    }
    .commodity-two-item-text {
      padding: 9px 10px 18px 10px;
      box-sizing: border-box;
      text-align: left;
    }
    .commodity-two-item-title {
      font-size: 28px;
      color: #333;
      text-align: center;
      width: 100%;
      font-family: PingFangSC-Regular, sans-serif;
      text-align: left;
      margin-bottom: 10px;
    }
    .commodity-tags-placehold {
      margin-bottom: 12px;
    }
    .commodity-tags-h5 {
      // margin-bottom: 12px;
    }
    .commodity-price-box-h5 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .apply-btn-h5 {
        font-size: 24px;
      }
    }
  }
</style>